import React, { Fragment } from "react";
import { withStyles, Button } from "@material-ui/core";
import RestoreIcon from "@material-ui/icons/Restore";
import DataGrid from "../../../../dataGrid"
import TerminalDropdown from "../../TerminalDropdown";
import styles from "../../styles";
import GridConfig from "./gridConfig";
import { postData} from "../../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import appConstant from "../../../../../appConstants";
import MESSAGES from "../../../../../appMessages";
import {withFeatureFlags} from "../../../../../userProfile/featureFlagsContext"

import { observer, inject } from "mobx-react";
import { withAppConfig } from "../../../../../appConfigContext";
@inject ('CommonStore')
@observer
class TrailerInventory extends React.Component {
    constructor(props){
        super(props);       
        this.gridConfig = new GridConfig({
        featureFlags: {
            IsWeightBasedRoutingEnabled: this.props.featureFlags.isFeatureEnabled(
            appConstant.features.isWeightBasedRouting
            ),
            showTempTypeTrailer: this.props.configJSON?.showDateRangeInShipmentSelection,
        },
        });
        this.state= {
            terminalID : 1,
            trailerInventoryData: null,
            errorMessage: null
        }
    }

    onGridReady = ({api}) => {
        this.gridApi = api;
    }

    onCellValueChanged = (params) => {
        if(params.colDef.field === "scenarioCount" &&  params.oldValue !== params.newValue && !(params.oldValue === null && params.newValue === "")){
            if(params.newValue !== "" && params.newValue > params.data.totalCount){
                this.props.enqueueSnackbar(MESSAGES.TRAILER.UPDATE_CUSTOMVALUE_ISGREATER, {variant: "error"});
                params.data[params.colDef.field] = params.oldValue;
                this.gridApi.refreshCells();
            } else {
                this.updateTrailerInventoryData(params);
            }

        }
    }

    updateTrailerInventoryData = (params) => {
        const {scenarioID} = this.props.userData.userProfile;
        const {trailerId} = params.data;
        const requestParams = {
            scenarioId: scenarioID,
            trailerList:[{
                trailerId,
                value: params.newValue === appConstant.EMPTY_STRING ? null : params.newValue
            }]
        }
        postData("UpdateTrailers", requestParams).then(response =>{
            if(Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(`Updated ${params.data.trailerName} custom value`, {variant: "success"});
            } else {
                this.props.enqueueSnackbar(`Error updating ${params.data.trailerName} custom value`, {variant: "error"});
                params.data[params.colDef.field] = params.oldValue;
                this.gridApi.refreshCells();
            }
        }, error => {
            this.props.enqueueSnackbar(`Error updating ${params.data.trailerName} custom value`, {variant: "error"});
            params.data[params.colDef.field] = params.oldValue;
            this.gridApi.refreshCells();
        })
    }


    render(){
        const { classes } = this.props;
        const  trailerInventoryData = this.props.CommonStore.trailersData.length > 0 ? this.props.CommonStore.trailersData.slice() : "";
        return (
            <Fragment>
                <header className={classes.moduleHeader}  data-automationid="trailerInventory-title"> Trailer Inventory </header>
                <div className={classes.moduleContainer}>
                    <div className={classes.moduleMessage}>
                        {`Trailers available at the  ${this.props.configJSON.terminalAccessLabel.fullName.toLowerCase()}. Trailer properties can be modified here. Note: Optimization results will be affected.`}
                    </div>
                    <div className={classes.terminalContainer}>
                        <span className={classes.terminalText}>{ this.props.configJSON.terminalAccessLabel.fullName } : </span>
                        <span className={classes.terminalDropdown}>
                            <TerminalDropdown onChange={this.onTerminalChange} selectedTerminalID={this.state.terminalID} />
                        </span>
                    </div>
                    <div className={`${classes.gridContainer}`}>
                    <div className={`${classes.dataGrid} ${classes.trailerInventoryGrid}`}>
                           {!this.state.errorMessage ? (
                            <DataGrid
                                columnDefs={this.gridConfig.config.columns}
                                config={this.gridConfig.config}
                                enableFilter={this.gridConfig.config.enableFilter}
                                enableSorting={this.gridConfig.config.enableSorting}
                                rowData={trailerInventoryData}
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChanged}
                            />
                               ): (
                                <div className={classes.errorMessageContainer}>
                                        <div className={classes.errorMessage}> {this.state.errorMessage} </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div >
                        <Button color="primary" variant="contained" size="small" classes={{root: classes.actionButton, disabled: classes.actionDisabled}} disabled>
                           <RestoreIcon classes={{root: classes.restoreIcon}} /> Restore to Defaults
                        </Button>
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default compose(withStyles(styles), withUserProfile, withSnackbar, withFeatureFlags, withAppConfig)(TrailerInventory)